// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3OohD","info":"Note_info__2JblN","note":"Note_note__1MdVt","actions":"Note_actions__2eRz3"};